// extracted by mini-css-extract-plugin
export var center = "_3x-2";
export var clickableRow = "_3x-5";
export var expandedRow = "_3x-7";
export var hoverable = "_3x-4";
export var left = "_3x-1";
export var right = "_3x-3";
export var row = "_3x-0";
export var selectedRow = "_3x-6";
export var summaryRow = "_3x-8";